export enum XpassStatusLabels {
  CONFIRMED = 'Confirmed',
  TRICYCLE = 'Tricycle',
  BOAT = 'Boat',
  ETRIKE = 'E-trike',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
}
